export enum LocationInputMethod {
	Pop = 'Pop',
	Address = 'Address',
	Coordinates = 'Coordinates',
}
